"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchMenu = void 0;
const react_1 = __importStar(require("react"));
const forms_1 = require("../../forms");
const __1 = require("..");
const SwitchMenu_styles_1 = require("./SwitchMenu.styles");
const SwitchMenu = ({ items, noMatchResultDescription: noMatchResultDesc, noMatchResultHeader, placeholder, open, setOpen, titleOnly, openProduct, isPopup, }) => {
    const [inputVal, setInputVal] = (0, react_1.useState)("");
    const [filteredItems, setFilteredItems] = (0, react_1.useState)(items);
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!items || (items === null || items === void 0 ? void 0 : items.length) === 0) {
            return;
        }
        const updatedItems = items.filter((item) => item.title.toLowerCase().trim().includes(inputVal.toLowerCase().trim()));
        setFilteredItems(updatedItems);
    }, [inputVal, items]);
    (0, react_1.useEffect)(() => {
        if (ref && ref.current) {
            ref.current.focus();
        }
    }, [open]);
    const toggleMenu = (clicked) => {
        if (clicked) {
            setOpen(false);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(SwitchMenu_styles_1.Wrapper, { isPopup: isPopup },
        react_1.default.createElement(SwitchMenu_styles_1.InputWrapper, null,
            react_1.default.createElement(forms_1.TextInputField, { label: "", placeholder: placeholder, value: inputVal, unit: "", onChange: (val) => setInputVal(val) })),
        react_1.default.createElement(SwitchMenu_styles_1.ResultWrapper, null, filteredItems && filteredItems.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null, filteredItems.map((item, index) => (react_1.default.createElement(__1.SwitchMenuItem, Object.assign({ key: index }, item, { titleOnly: titleOnly, openProduct: openProduct, externalLinkClicked: (clicked) => toggleMenu(clicked) })))))) : (react_1.default.createElement(SwitchMenu_styles_1.NoMatchResultWrapper, null,
            react_1.default.createElement(SwitchMenu_styles_1.NoMatchResultHeader, null, noMatchResultHeader),
            react_1.default.createElement(SwitchMenu_styles_1.NoMatchResultDesc, null, noMatchResultDesc))))))));
};
exports.SwitchMenu = SwitchMenu;
//# sourceMappingURL=SwitchMenu.js.map